import React from 'react';

const AIAnalysis = () => {
    return (
        <div className="container mx-auto mt-10">
            <div className="bg-white p-8 rounded-lg shadow-lg">
                <h2 className="text-3xl font-bold text-blue-700 mb-6 text-center">AI Health Analysis</h2>
                <p className="text-gray-700 text-lg">
                    Our AI-powered health analysis tool provides you with accurate and personalized health insights. Simply upload your health data, and let our AI do the rest.
                </p>
                <div className="mt-6 text-center">
                    <button className="bg-green-500 text-white py-3 px-6 rounded-lg font-bold hover:bg-green-600 transition duration-300 ease-in-out">
                        Upload Health Data
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AIAnalysis;
